"use client";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useMemo } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";
const THU_VI = [
  "Chủ nhật",
  "Thứ hai",
  "Thứ ba",
  "Thứ tư",
  "Thứ năm",
  "Thứ sáu",
  "Thứ bảy",
];

const BetOKDateTabs = ({ selectedDate, onDateChange, compact }) => {
  const today = useMemo(() => dayjs().tz(TZ), []);
  const todayString = today.format("YYYY-MM-DD");

  const dateOptions = useMemo(() => {
    const options = [];

    options.push({
      value: "live",
      label: "Kèo trực tuyến",
      dateLabel: null,
    });

    options.push({
      value: todayString,
      label: "Hôm nay",
      dateLabel: today.format("DD/MM"),
    });

    const tomorrow = today.clone().add(1, "day");
    options.push({
      value: tomorrow.format("YYYY-MM-DD"),
      label: "Ngày mai",
      dateLabel: tomorrow.format("DD/MM"),
    });

    for (let i = 2; i <= 6; i++) {
      const d = today.clone().add(i, "day");
      options.push({
        value: d.format("YYYY-MM-DD"),
        label: THU_VI[d.day()],
        dateLabel: d.format("DD/MM"),
      });
    }

    return options;
  }, [todayString]);

  return (
    <div
      className={`flex w-full ${compact ? "h-full min-h-0 items-stretch" : "items-center mb-4 mt-2 md:mb-6 md:mt-4"}`}
    >
      <div className="kbv-date-tabs-scroll flex h-full w-full min-w-0 gap-2 overflow-x-auto overflow-y-hidden scroll-smooth items-center">
        {dateOptions.map((opt, idx) => {
          const isSelected = selectedDate === opt.value;
          return (
            <button
              key={opt.value}
              id={`day-filter-${idx}`}
              data-cy={`day-filter-${idx}`}
              type="button"
              onClick={() => onDateChange(opt.value)}
              className={`kbv-date-tab flex items-center justify-center rounded-lg border-[1px] md:text-sm font-semibold text-xs md:px-4 px-3 h-14 shrink-0 md:min-w-[96px] min-w-[72px] transition-colors duration-150 ${
                isSelected ? "kbv-date-tab--selected" : "kbv-date-tab--unselected"
              }`}
            >
              <p
                id="day-filter-text"
                data-cy="day-filter-text"
                className="flex flex-col items-center"
              >
                <span
                  id="day-filter-text-name"
                  data-cy="day-filter-text-name"
                  className="md:text-sm text-xs font-semibold -mx-1"
                >
                  {opt.label}
                </span>
                {opt.dateLabel && (
                  <span
                    id="day-filter-text-value"
                    data-cy="day-filter-text-value"
                    className="kbv-date-label md:text-sm text-xs"
                  >
                    {opt.dateLabel}
                  </span>
                )}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BetOKDateTabs;
